module.exports = __webpack_public_path__ + "static/svitolina-red-0a6903350412bfb431c3ee484ee0a070.png";